import { createAction, props } from '@ngrx/store';

export const numSorteLoad = createAction('[NS] Load', props<{ token: string }>());

export const numSorteSuccess  = createAction('[NS] Loaded', props<{ items: any }>());

export const numSorteError = createAction('[NS] Error', props<{ error: any }>());